import { ActivityIcon } from '@jouzen/ecom-components/icons/ActivityIcon';
import { HeartOrganIcon } from '@jouzen/ecom-components/icons/HeartOrganIcon';
import { MeditationIcon } from '@jouzen/ecom-components/icons/MeditationIcon';
import { MetabolicHealthWaveIcon } from '@jouzen/ecom-components/icons/MetabolicHealthWaveIcon';
import { MoonIcon } from '@jouzen/ecom-components/icons/MoonIcon';
import { StressIcon } from '@jouzen/ecom-components/icons/StressIcon';

import type { TextColProps } from '@/app/components/TwoColumnModule';

const defaultParagraphs: TextColProps['paragraphs'] = [
  {
    icon: HeartOrganIcon,
    textProps: {
      label: 'ring_pdp_2025_membership_section_highlight_1',
    },
  },
  {
    icon: MoonIcon,
    textProps: {
      label: 'ring_pdp_2025_membership_section_highlight_2',
    },
  },
  {
    icon: ActivityIcon,
    textProps: {
      label: 'ring_pdp_2025_membership_section_highlight_3',
    },
  },
  {
    icon: StressIcon,
    textProps: {
      label: 'ring_pdp_2025_membership_section_highlight_4',
    },
  },
  {
    icon: MeditationIcon,
    textProps: {
      label: 'ring_pdp_2025_membership_section_highlight_5',
    },
  },
  {
    icon: MetabolicHealthWaveIcon,
    textProps: {
      label: 'ring_pdp_2025_membership_section_highlight_6',
    },
  },
];

export default defaultParagraphs;
